exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Filter__root,\n.DS__Filter__list {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__Filter__root {\n  position: relative;\n  display: flex;\n  width: -webkit-min-content;\n  width: min-content;\n}\n\n  .DS__Filter__root.DS__Filter__block {\n    width: 100%;\n  }\n\n.DS__Filter__list {\n  position: absolute;\n}\n\n.DS__Filter__list.DS__Filter__placement_bottomLeft {\n    top: calc(100% + 8px);\n    left: 0;\n  }\n\n.DS__Filter__list.DS__Filter__placement_bottomRight {\n    top: calc(100% + 8px);\n    right: 0;\n  }\n\n.DS__Filter__list.DS__Filter__placement_topLeft {\n    bottom: calc(100% + 8px);\n    left: 0;\n  }\n\n.DS__Filter__list.DS__Filter__placement_topRight {\n    right: 0;\n    bottom: calc(100% + 8px);\n  }\n\n.DS__Filter__list.DS__Filter__block {\n    width: 100%;\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__Filter__root",
	"list": "DS__Filter__list",
	"block": "DS__Filter__block",
	"placement_bottomLeft": "DS__Filter__placement_bottomLeft",
	"placement_bottomRight": "DS__Filter__placement_bottomRight",
	"placement_topLeft": "DS__Filter__placement_topLeft",
	"placement_topRight": "DS__Filter__placement_topRight"
};